import { africanMarkets } from '@/mocks/markets';

/** The label used for the "select every market" shortcut. */
export const ALL_AFRICAN_MARKETS = 'All African Countries';

function currencyForMarket(name: string): string | undefined {
  return africanMarkets.find((market) => market.name === name)?.currency;
}

/** The distinct settlement currencies implied by the selected markets, in order. */
export function currenciesForMarkets(names: string[]): string[] {
  const currencies: string[] = [];
  names.forEach((name) => {
    const currency = currencyForMarket(name);
    if (currency && !currencies.includes(currency)) currencies.push(currency);
  });
  return currencies;
}

/** A readable label for a set of selected markets, used in headers and exports. */
export function marketFilterLabel(selected: string[]): string {
  if (selected.length === 0) return ALL_AFRICAN_MARKETS;
  if (selected.length === 1) return selected[0];
  if (selected.length === allAfricanMarketsLength()) return ALL_AFRICAN_MARKETS;
  return `${selected.length} markets`;
}

function allAfricanMarketsLength(): number {
  return africanMarkets.length;
}